

export const Header=()=>{
    
    return(
        <div className="header">
            <div className="header_container">
                <div className="header_row">
                    <a className="header_link"><p>about us</p></a>
                    <a className="header_link"><p>work</p></a>
                    <div>
                        <img src={require('../../static/main-logo.png')}/>
                    </div>
                    <a className="header_link"><p>shop</p></a>
                    <a className="header_link"><p>contact</p></a>
                </div>
            </div>
        </div>
    )
}